import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "statistics-panel" }
const _hoisted_2 = { class: "stats-header" }
const _hoisted_3 = { class: "last-update" }
const _hoisted_4 = { class: "stats-grid" }
const _hoisted_5 = { class: "stats-section" }
const _hoisted_6 = { class: "stats-cards" }
const _hoisted_7 = { class: "stat-card" }
const _hoisted_8 = { class: "stat-value" }
const _hoisted_9 = { class: "stat-card" }
const _hoisted_10 = { class: "stat-value" }
const _hoisted_11 = { class: "stat-card" }
const _hoisted_12 = { class: "stat-value" }
const _hoisted_13 = { class: "stats-section" }
const _hoisted_14 = { class: "stats-cards" }
const _hoisted_15 = { class: "stat-card" }
const _hoisted_16 = { class: "stat-value" }
const _hoisted_17 = { class: "stat-card" }
const _hoisted_18 = { class: "stat-value" }
const _hoisted_19 = { class: "stat-card" }
const _hoisted_20 = { class: "stat-value" }
const _hoisted_21 = { class: "stats-section" }
const _hoisted_22 = { class: "stats-cards" }
const _hoisted_23 = { class: "stat-card" }
const _hoisted_24 = { class: "stat-value" }
const _hoisted_25 = { class: "stat-card" }
const _hoisted_26 = { class: "stat-value" }
const _hoisted_27 = { class: "stat-card" }
const _hoisted_28 = { class: "stat-value" }
const _hoisted_29 = { class: "stats-section" }
const _hoisted_30 = { class: "fuel-stats" }
const _hoisted_31 = { class: "fuel-gauge-large" }
const _hoisted_32 = { class: "gauge-container" }
const _hoisted_33 = { class: "gauge-text" }
const _hoisted_34 = { class: "stats-section span-2" }
const _hoisted_35 = { class: "vehicle-info-grid" }
const _hoisted_36 = { class: "info-row" }
const _hoisted_37 = { class: "info-value monospace" }
const _hoisted_38 = { class: "info-row" }
const _hoisted_39 = { class: "info-value" }
const _hoisted_40 = { class: "info-row" }
const _hoisted_41 = { class: "info-value" }
const _hoisted_42 = { class: "info-row" }
const _hoisted_43 = { class: "info-value" }

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'StatisticsPanel',
  props: {
    stats: {},
    latestData: {}
  },
  setup(__props: any) {

const props = __props;

const latestTimestamp = computed(
  () => props.stats?.latest_timestamp || props.latestData?.timestamp
);

function formatTimestamp(timestamp: number) {
  if (!timestamp) return "N/D";
  return new Date(timestamp * 1000).toLocaleString("it-IT");
}

function formatPeriod() {
  if (!props.stats?.earliest_timestamp || !props.stats?.latest_timestamp) {
    return "N/D";
  }

  const start = new Date(props.stats.earliest_timestamp * 1000);
  const end = new Date(props.stats.latest_timestamp * 1000);

  const diffMs = end.getTime() - start.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffHours = Math.floor(
    (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );

  if (diffDays > 0) {
    return `${diffDays}g ${diffHours}h`;
  } else if (diffHours > 0) {
    return `${diffHours} ore`;
  } else {
    return "< 1 ora";
  }
}

function calculateSpeedStats() {
  // In una implementazione reale, qui calcoleresti le statistiche dai dati storici
  return {
    avg: props.latestData?.vehicle_speed || 0,
    max: props.latestData?.vehicle_speed || 0,
    min: props.latestData?.vehicle_speed || 0,
  };
}

function calculateRpmStats() {
  // In una implementazione reale, qui calcoleresti le statistiche dai dati storici
  return {
    avg: props.latestData?.engine_rpm || 0,
    max: props.latestData?.engine_rpm || 0,
    min: props.latestData?.engine_rpm || 0,
  };
}

function getBatteryClass(level: number) {
  if (level >= 70) return "high";
  if (level >= 30) return "medium";
  return "low";
}

function getBatteryStatus(level: number) {
  if (level >= 70) return "Ottimo";
  if (level >= 30) return "Medio";
  return "Basso";
}

function formatLocation() {
  if (!props.latestData?.latitude || !props.latestData?.longitude) {
    return "N/D";
  }
  return `${props.latestData.latitude.toFixed(
    6
  )}, ${props.latestData.longitude.toFixed(6)}`;
}

function calculateUptime() {
  // Esempio: calcola dal primo timestamp
  if (!props.stats?.earliest_timestamp) return "N/D";

  const start = new Date(props.stats.earliest_timestamp * 1000);
  // console.log("🚀 [calculateUptime] start:", start);
  const now = new Date();
  // console.log("🚀 [calculateUptime] now:", now);
  const diffMs = now.getTime() - start.getTime();

  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffHours = Math.floor(
    (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );

  if (diffDays > 0) {
    return `${diffDays}g ${diffHours}h`;
  } else if (diffHours > 0) {
    return `${diffHours}h`;
  } else {
    return "< 1h";
  }
}

function exportData() {
  // Implementa l'esportazione dati
  console.log("Esportazione dati...");
  // Qui potresti implementare il download CSV/JSON
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Statistiche Dettagliate", -1)),
      _createElementVNode("span", _hoisted_3, " Ultimo aggiornamento: " + _toDisplayString(formatTimestamp(latestTimestamp.value)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Generali", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "stat-label" }, "Record Totali", -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(__props.stats.total_records || 0), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "stat-label" }, "Veicoli Unici", -1)),
            _createElementVNode("span", _hoisted_10, _toDisplayString(__props.stats.unique_vehicles || 0), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "stat-label" }, "Periodo Monitorato", -1)),
            _createElementVNode("span", _hoisted_12, _toDisplayString(formatPeriod()), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[8] || (_cache[8] = _createElementVNode("h4", null, "Velocità", -1)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "stat-label" }, "Media", -1)),
            _createElementVNode("span", _hoisted_16, _toDisplayString(calculateSpeedStats().avg.toFixed(1)) + " km/h", 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "stat-label" }, "Massima", -1)),
            _createElementVNode("span", _hoisted_18, _toDisplayString(calculateSpeedStats().max) + " km/h", 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "stat-label" }, "Minima", -1)),
            _createElementVNode("span", _hoisted_20, _toDisplayString(calculateSpeedStats().min) + " km/h", 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _cache[12] || (_cache[12] = _createElementVNode("h4", null, "Motore", -1)),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "stat-label" }, "RPM Medio", -1)),
            _createElementVNode("span", _hoisted_24, _toDisplayString(calculateRpmStats().avg.toFixed(0)), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "stat-label" }, "Temperatura", -1)),
            _createElementVNode("span", _hoisted_26, _toDisplayString(__props.latestData?.engine_temperature || 0) + "°C", 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "stat-label" }, "Carico", -1)),
            _createElementVNode("span", _hoisted_28, _toDisplayString(__props.latestData?.engine_load || 0) + "%", 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _cache[15] || (_cache[15] = _createElementVNode("h4", null, "Carburante", -1)),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "gauge-background" }, null, -1)),
              _createElementVNode("div", {
                class: "gauge-fill",
                style: _normalizeStyle({ height: `${__props.latestData?.fuel_level || 0}%` })
              }, null, 4),
              _createElementVNode("div", _hoisted_33, _toDisplayString(__props.latestData?.fuel_level || 0) + "%", 1)
            ]),
            _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"fuel-info\" data-v-908c9606><div class=\"info-item\" data-v-908c9606><span class=\"info-label\" data-v-908c9606>Consumo stimato</span><span class=\"info-value\" data-v-908c9606>-- L/100km</span></div><div class=\"info-item\" data-v-908c9606><span class=\"info-label\" data-v-908c9606>Autonomia residua</span><span class=\"info-value\" data-v-908c9606>-- km</span></div></div>", 1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _cache[20] || (_cache[20] = _createElementVNode("h4", null, "Informazioni Veicolo", -1)),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "info-label" }, "VIN:", -1)),
            _createElementVNode("span", _hoisted_37, _toDisplayString(__props.latestData?.vin || "N/D"), 1)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "info-label" }, "Ultima posizione:", -1)),
            _createElementVNode("span", _hoisted_39, _toDisplayString(formatLocation()), 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "info-label" }, "Acceleratore:", -1)),
            _createElementVNode("span", _hoisted_41, _toDisplayString(__props.latestData?.throttle_position || 0) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "info-label" }, "Tempo attivo:", -1)),
            _createElementVNode("span", _hoisted_43, _toDisplayString(calculateUptime()), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", { class: "stats-footer" }, [
      _createElementVNode("button", {
        onClick: exportData,
        class: "export-btn"
      }, [...(_cache[21] || (_cache[21] = [
        _createElementVNode("span", null, "📊", -1),
        _createTextVNode(" Esporta Dati ", -1)
      ]))]),
      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "data-note" }, " Dati aggiornati in tempo reale • Intervallo di polling: 30s ", -1))
    ])
  ]))
}
}

})